import PropTypes from 'prop-types';

import { Spacings, TextColors } from '../../styleConstants';

const Icon = ({
  width,
  height,
  color,
  onClick,
  className,
  path,
  size,
  children,
  viewBox,
  pathFillRule,
  pathClipRule,
  stroke,
  strokeWidth,
  strokeLinecap,
  strokeLinejoin
}) => (
  <svg
    width={size || width}
    height={size || height}
    viewBox={viewBox}
    onClick={onClick}
    className={className}
  >
    {path && (
      <path
        d={path}
        fill={color}
        fillRule={pathFillRule}
        clipRule={pathClipRule}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
        strokeLinejoin={strokeLinejoin}
      />
    )}
    {children}
  </svg>
);

export default Icon;

Icon.propTypes = {
  path: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  viewBox: PropTypes.string,
  pathFillRule: PropTypes.string,
  pathClipRule: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
  strokeLinecap: PropTypes.string,
  strokeLinejoin: PropTypes.string
};

Icon.defaultProps = {
  color: TextColors.BLACK,
  size: Spacings.SPACING_3B,
  className: '',
  width: Spacings.SPACING_3B,
  height: Spacings.SPACING_3B,
  onClick: () => {},
  children: null,
  viewBox: '0 0 80 80',
  pathFillRule: 'unset',
  pathClipRule: 'unset',
  stroke: null,
  strokeWidth: null,
  strokeLinecap: 'butt',
  strokeLinejoin: 'miter'
};
